import { UserDtoSchema } from "@modules/profile/profileDtos"
import { SharedCoachStatus } from "@modules/programs/programTypes"
import { z } from "zod"

export const SharedCoachDtoSchema = z.object({
  role: z.string(),
  status: z.nativeEnum(SharedCoachStatus),
  user: UserDtoSchema,
})

export type SharedCoachDto = z.infer<typeof SharedCoachDtoSchema>

export enum SharedCoachRole {
  STANDARD = "STANDARD",
}
